.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  max-width: 1440px;
  margin: 0 auto;
  gap: 12px;
  list-style: none;
  padding: 0;
  padding-bottom: 20px;
}

.card {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  cursor: pointer;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  background-color: #222;
}

.card:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.image {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center;
  display: block;
}

.title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  margin: 0;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.85);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-sizing: border-box;
  text-align: center;
  transition: background 0.3s ease;
}

.card:hover .title {
  background: rgba(0, 0, 0, 0.8);
}
